<template>
  <main  class="page-padding page-sidebar">
    <section class="assigned-roles-list">

      <header class="assigned-roles-header">
        <div class="header_left">
          <h2 class="title">
            <span>{{ $t('roles.rolesList') }}</span>
          </h2>

          <div v-if="columns.length" @click="toggleAll" class="check-group">
            <checkAllIcon />
            <span class="check-number">{{checkedRoles.length}}</span>
            <span class="check-action">
          {{ checkedRoles.length === this.assignedRolesWidthPendingRoles.length ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
          </div>
        </div>

        <button type="button"
                @click="checkDelUser"
                v-if="checkedRoles.length > 0"
                class="control-btn-new hover-blue-new hint-cont">
          <del-icon></del-icon>
          <p class="btn-hint btn-hint_bottom">
            {{$t('btns.users.rejectRoles')}}
          </p>
        </button>
      </header>

      <table-component :class-name="'assigned-roles-cont'"
                       :column-width="columnWidth"
                       :legend="createLegend()"
                       :columns="columns"
                       @roleForReject="singleRoleReject"
                       @roleForConfirm="singleRoleConfirm"
                       @changeCheckbox="checkedRoles = $event"
                       :all-checked="allChecked"
                       :clear-checked="clearMarker"
                       :tableWithButtons="true"
                       @checkAll="checkAll"></table-component>
    </section>
  </main>
</template>

<script>
  import {sidebarState} from "../../mixins/utils/sidebarState"
  import {tableComponentMixin} from "../../mixins/utils/tableComponentMixin"
  import {showOverlay} from "../../mixins/utils/showOverlay"
  import {mapActions, mapGetters, mapState} from "vuex"
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute"
  import {delItem2} from "../../mixins/delItem2"
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import trimItem from '../../components/trimITem'
  import delIcon from '../../components/Svg/cart_control/delIcon'
  import checkAllIcon from '../../components/Svg/projects/checkAllIcon'


  export default {
    name: "AssignedRoles",
    mixins: [sidebarState , tableComponentMixin, tokenAndRoute, showOverlay, delItem2, loaderMixin],
    components: { trimItem, delIcon, checkAllIcon, },
    data() {
      return {
        checkedRoles: [],
        legend: [],
        columnWidth: [100],
        assignedRolesWidthPendingRoles: [],
        clearMarker: false,
      }
    },
    mounted() {
      // console.log('allNotify mounted', this.allNotify)
      // console.log('assignedRoles mounted', this.assignedRoles)
      // console.log('checkedRoles', this.checkedRoles)
    },
    computed: {
      ...mapState({
        assignedRoles: state => state.roles.assignedRoles,
        allNotify: state => state.roles.allNotify,
        user: state => state.auth.user,
      }),
      ...mapGetters({}),

      columns() {
        this.assignedRolesWidthPendingRoles = [...this.assignedRoles]

        this.allNotify.forEach(item => {
          if (item.type_id === 1) {
            this.assignedRolesWidthPendingRoles.unshift({
              id: item.role.id, //id роли
              name: item.role.name,
              notify_id: item.id //id уведомления
            })
          }
        })
        // console.log(this.assignedRolesWidthPendingRoles)

        return this.assignedRolesWidthPendingRoles.map(item => {
          return {
            id: item.id,
            item,
            notify_id: item.notify_id,
            cells: [
              {
                text: {
                  text: item.name,
                  isLink: true,
                  link: `roles/role/${item.id}`,
                  linkColor: false,
                  isTrimmed: true,
                  trimWidth: 50
                },
                avatar: {
                  isAvatar: false
                }
              },
              {
                text: {
                  text: ''
                },
                confirmRoleButtons: true,
                avatar: {
                  isAvatar: false,
                }
              },
            ]
          }
        })
      },

      allChecked() {
        if (this.assignedRolesWidthPendingRoles) {
          return this.checkedRoles.length === this.assignedRolesWidthPendingRoles.length && this.checkedRoles.length > 0
        } else {
          return false
        }
      },
    },
    methods: {
      ...mapActions({
        loadAssignedRoles: 'roles/getAssignedRoles',
        deleteRoleAssignment: 'roles/deleteRoleAssignment',
        confirmInvite: 'roles/confirmInvite',
        rejectInvite: 'roles/rejectInvite',
        getAllNotify: 'roles/getAllNotify',
        readInvite: 'roles/readInvite'
      }),
      createLegend() {
        return this.legend = [
          {
            text: this.$t('users.table.contactPerson'),
          },
          {
            text: 'Принять/Отклонить роль',
            legendSort: false
          },
        ]
      },
      toggleAll() {
        if (!this.allChecked) {
          this.checkedRoles = this.assignedRolesWidthPendingRoles
          this.clearMarker = false;
        } else {
          this.checkedRoles = []
          this.clearMarker = true;
        }
      },
      returnUsersAvatar(item) {
        return item.users.map(item => {
          return item.contacts.avatar_url
        })
      },
      checkAll() {
        if (this.allChecked) {
          this.checkedRoles = []
        } else {
          this.checkedRoles = this.assignedRolesWidthPendingRoles
        }
      },
      async singleRoleReject(item) {
        //если действий по принятию/отклонению еще не было
        if (item.notify_id) {
          try {
            // console.log('Клик confirm в assigmentRoles по item --->', item)
            await this.rejectInvite({
              token: this.token,
              role_id: item.id
            })
            await this.readInvite({
              token: this.token,
              notify_id: item.notify_id
            })
            await this.getAllNotify()
            await this.loadAssignedRoles(this.token)
          } catch (error) {
            console.log('Ошибка отклонения назначенной, но еще не принятой роли', error)
          }
        } else {
          //если отклонить нужно уже принятую РАНЕЕ роль
          try {
            // console.log('Клик reject в assigmentRoles по item --->', item)
            await this.deleteRoleAssignment({
              roleId: item.id,
              userId: this.user.id
            })
            await this.loadAssignedRoles(this.token)
          } catch (error) {
            console.log('Ошибка отклонения уже принятой роли', error)
          }
        }
      },
      async singleRoleConfirm(item) {
        try {
          // console.log('Поймал клик confirm в assigmentRoles по item --->', item)
          await this.confirmInvite({
            token: this.token,
            role_id: item.id
          })
          await this.readInvite({
            token: this.token,
            notify_id: item.notify_id
          })
          await this.getAllNotify()
          await this.loadAssignedRoles(this.token)
        } catch (error) {
          console.log('Ошибка подтверждения принятия роли', error)
        }
      },
      checkDelUser() {
        let string = '';
        this.checkedRoles.forEach(item => {
          string = `все выделенные роли?`
        });
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
        this.setNumberDel(2);
      },
      deleteItems2() {
        this.delUser()
      },
      async delUser() {
        this.showLoader();
        for (let i = 0; i < this.checkedRoles.length; i++) {
          let item = this.checkedRoles[i];
          try {
            await this.singleRoleReject(item)
          } catch (error) {
            console.log('Ошибка в отклонении/удалении серии ролей', error)
          }
        };
        this.clearMarker = true;
        this.checkedRoles = [];
        this.clearMarker = false;
        this.hideLoader()
      }
    }
  }
</script>

<style lang="scss" scoped>
.assigned-roles-header {
  position: sticky;
  top: 90px;
  z-index: 1;
  background: #f5f8fa;
  padding: 0 20px 20px 20px;
  height: 54px;
  border-bottom: 1px solid #D7E3EA;
  display: flex;
  justify-content: space-between;

}
.assigned-roles-cont {
  padding-top: 15px;
}

.header_left {
  display: flex;

  .title {
    margin-right: 30px;
  }
}

.check-group {
  margin-right: 10px;
  min-width: 150px;
  height: 40px;
  border: 1px solid rgba(16, 156, 241, 0.36);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.25px;
  color: #109CF1;

  svg {
    margin-right: 10px;
    margin-left: 18px;
  }

  .check-number {
    margin-right: auto;
  }

  .check-action {
    cursor: pointer;
    margin: 0 18px;
  }
}
//fix подсказки, чтобы не уезжала вправо за экран
.assigned-roles-header .control-btn-new .btn-hint {
  left: -70px;
  width: 148px;
  min-width: 148px;
}
</style>
